export type SelectOption = {
  value: string;
  label: string;
};

export type FilterSuggestionType = "city" | "route" | "property";

export type FilterSuggestion = {
  type: FilterSuggestionType;
  label: string;
  value: string;
};

const DEFAULT_LIMIT = 8;
const MIN_QUERY_LENGTH = 2;

function matchesQuery(label: string, query: string): boolean {
  return label.toLowerCase().includes(query.toLowerCase());
}

function toSuggestions(
  type: FilterSuggestionType,
  options: SelectOption[],
  query: string,
): FilterSuggestion[] {
  return options
    .filter(
      (option) =>
        typeof option === "object" &&
        typeof option.label === "string" &&
        matchesQuery(option.label, query),
    )
    .map((option) => ({
      type,
      label: option.label,
      value: option.value,
    }));
}

/**
 * Build autocomplete suggestions for Property History filter options.
 * Order preference: city, then route, then property. Caps at `limit`.
 */
export function buildFilterSuggestions(
  query: string,
  options: {
    cities: SelectOption[];
    routes: SelectOption[];
    properties: SelectOption[];
  },
  limit: number = DEFAULT_LIMIT,
): FilterSuggestion[] {
  const trimmed = query.trim();
  if (trimmed.length < MIN_QUERY_LENGTH) {
    return [];
  }

  const suggestions = [
    ...toSuggestions("city", options.cities, trimmed),
    ...toSuggestions("route", options.routes, trimmed),
    ...toSuggestions("property", options.properties, trimmed),
  ];

  return suggestions.slice(0, limit);
}
